import React from 'react'
import "../css/loader.css"

export default function Loader() {
  return (
    <div className="loader">

    </div>
  )
}
